<template lang="pug">
  section(id="time")
     .goscontainer
        v-row.device(no-gutters)
            v-col(cols=2 md=1)
                v-img(:src="require('@/assets/img/home/covid.png')")
            v-col.pl-4(cols=10 md=5)
                div.head Решение, продиктованное временем: удаленные судебные заседания и видеоконференцсвязь с идентификацией личности без специального оборудования и установки дополнительных программ
                div.body Узнайте, как наши разработки могут быть Вам полезны в период пандемии
            
</template>

<script>
  export default {
    name: 'SectionTime',
  }
</script>

<style lang="sass" scoped>
  #time
    padding: 24px 16px 16px
    background-color: #FFFFFF
    color: #000000
    .device
        font-family: $slab
        font-weight: 300
        .head
            margin-top:16px
            font-size: 14px
            line-height: 16px
        .body
            margin-top:16px
            font-size: 14px
            color: #ED0E51

  @media (max-width: 1264px) 
    #time
      .device
          .head
              margin-top: 8px
</style>
